import React from 'react';
import { Button } from '../components/ui/button';
import { Compass, Sprout, HandHeart, Play, ArrowUpRight } from 'lucide-react';
import { site } from '../data/mock';
import { useI18n } from '../i18n/I18nProvider';

const ICONS = [Compass, Sprout, HandHeart];

export default function DiscoverGrowServe() {
  const { t } = useI18n();
  return (
    <section id="watch" className="relative py-24 lg:py-32 bg-[#f5efe3]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="text-[#b88a2a] text-xs uppercase tracking-wider-xtra font-medium">{t.dgs.eyebrow}</span>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#1f3a2a] mt-4 leading-[1.05]">{t.dgs.title_1} <span className="italic">{t.dgs.title_2}</span></h2>
          <p className="mt-6 text-[#4a5a4e] text-lg leading-relaxed">{t.dgs.sub}</p>
        </div>

        <div className="mt-14 grid lg:grid-cols-4 gap-5">
          {t.dgs.cards.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <div key={p.title} className="card-rise bg-white border border-[#e5dcc5] rounded-2xl p-7">
                <div className="w-12 h-12 rounded-xl bg-[#f0e9d8] flex items-center justify-center text-[#2e5340] mb-5">
                  <Icon size={22} strokeWidth={1.6} />
                </div>
                <h3 className="font-serif-display text-2xl text-[#1f3a2a]">{p.title}</h3>
                <p className="mt-3 text-[#4a5a4e] text-sm leading-relaxed">{p.text}</p>
              </div>
            );
          })}

          <div className="card-rise bg-[#1f3a2a] text-[#f5efe3] rounded-2xl p-7 flex flex-col justify-between">
            <div>
              <div className="w-12 h-12 rounded-xl bg-[#2e5340] flex items-center justify-center text-[#d4a63d] mb-5"><Play size={22} strokeWidth={1.6} /></div>
              <h3 className="font-serif-display text-2xl">{t.dgs.ytTitle}</h3>
              <p className="mt-3 text-[#f5efe3]/75 text-sm leading-relaxed">{t.dgs.ytText}</p>
            </div>
            <Button asChild className="mt-5 bg-[#d4a63d] hover:bg-[#b88a2a] text-[#1f3a2a] rounded-full h-11">
              <a href={site.youtube} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2">{t.dgs.ytBtn} <ArrowUpRight size={16} /></a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
